import Base from "./base";

export default class MovenPay extends Base {

    makeExternalPayment(newStep) {
        this.props.externalFunc.depositMovenPay({
            currentUrl: window.location.host
        }, (data) => {
            this.setState({
                externalUrl: data.urlToRedirect,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        this.props.externalFunc.depositMovenPay({
            currentUrl: window.location.host,
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.urlToRedirect,
                currentStep: newStep
            })
        });
    }

}
